import type CountryCode from '@alltrails/types/CountryCode';

/**
 * Maps ISO country codes to AllTrails location slugs
 * Used for fallback when IP-based location has no results
 */
const countryIsoToSlugMap: Partial<Record<CountryCode, string>> = {
  US: 'united-states',
  GB: 'united-kingdom',
  CA: 'canada',
  AU: 'australia',
  NZ: 'new-zealand',
  DE: 'germany',
  FR: 'france',
  ES: 'spain',
  IT: 'italy',
  PT: 'portugal',
  NL: 'netherlands',
  BE: 'belgium',
  CH: 'switzerland',
  AT: 'austria',
  DK: 'denmark',
  NO: 'norway',
  SE: 'sweden',
  FI: 'finland',
  IS: 'iceland',
  IE: 'ireland',
  PL: 'poland',
  CZ: 'czechia',
  SK: 'slovakia',
  HU: 'hungary',
  RO: 'romania',
  BG: 'bulgaria',
  HR: 'croatia',
  SI: 'slovenia',
  GR: 'greece',
  TR: 'turkey',
  MX: 'mexico',
  BR: 'brazil',
  AR: 'argentina',
  CL: 'chile',
  CO: 'colombia',
  PE: 'peru',
  EC: 'ecuador',
  CR: 'costa-rica',
  PA: 'panama',
  JP: 'japan',
  CN: 'china',
  IN: 'india',
  TH: 'thailand',
  VN: 'vietnam',
  MY: 'malaysia',
  ID: 'indonesia',
  PH: 'philippines',
  KR: 'south-korea',
  TW: 'taiwan',
  ZA: 'south-africa',
  KE: 'kenya',
  TZ: 'tanzania',
  UG: 'uganda',
  RW: 'rwanda',
  MA: 'morocco',
  EG: 'egypt',
  IL: 'israel',
  JO: 'jordan',
  AE: 'united-arab-emirates',
  SA: 'saudi-arabia',
  OM: 'oman',
  NP: 'nepal',
  LK: 'sri-lanka',
  PK: 'pakistan',
  BD: 'bangladesh'
};

/**
 * Converts an ISO country code to an AllTrails location slug
 * @param countryCode - Two-letter ISO country code (e.g., 'US', 'GB')
 * @returns Location slug (e.g., 'united-states', 'united-kingdom') or undefined if not mapped
 */
export function countryIsoToSlug(countryCode: string): string | undefined {
  return countryIsoToSlugMap[countryCode as CountryCode];
}
